<template>
    <div id="hive-information-widget-component">
        <WidgetWrapperComponent :title="$t('information_asset_widget_component.general_view')" id-widget="hive-information-widget">
            <template v-slot:default>
                <div id="information-asset-widget-container" class="information-asset-widget-container">
                    <template v-for="(n, index) in total_models">
                        <div :key="n" class="d-flex flex-column gap-2 position-relative">
                            <template v-if="configuration[index]?.['is_required']">
                                <div class="d-flex justify-center">
                                    <DisplayAssetContentLevelComponent
                                        :asset="asset"
                                        :asset_module="asset_module"
                                        :index_model="index"
                                        :scale="0.7"
                                    />
                                </div>

                                <div>
                                    <p class="mb-1 font-12 font-color-medium">Informations globales</p>

                                    <v-row class="pa-2">
                                        <v-col>
                                            <v-icon class="pr-2">mdi-beehive-outline</v-icon>
                                            <span>Contenu</span>
                                            <span class="pl-8 font-weight-bold">{{ $props.asset.asset_liquid.name }}</span>
                                        </v-col>

                                        <v-col>
                                            <v-icon class="pr-2">mdi-trophy-outline</v-icon>
                                            <span>Gain total</span>
                                            <span class="pl-8 font-weight-bold">{{ $props.asset.last_datas.net_weight[0] }} Kg</span>
                                        </v-col>

                                        <v-col>
                                            <v-icon class="pr-2">mdi-scale-bathroom</v-icon>
                                            <span class="pr-8">Poids net</span>
                                            <span class="pl-8 font-weight-bold">{{ $props.asset.weight }} Kg</span>
                                        </v-col>
                                    </v-row>

                                    <p class="mb-1 font-12 font-color-medium">Informations complémentaires</p>

                                    <v-row class="pa-2">
                                        <v-col cols="4">
                                            <v-icon class="pr-2">mdi-thermometer</v-icon>
                                            <span>Température</span>
                                            <span class="pl-8 font-weight-bold">{{ device.temperature }}°C</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-icon class="pr-2">mdi-wifi</v-icon>
                                            <span class="pr-8">Réception</span>

                                            <v-icon
                                                v-if="
                                                    device.signal_quality === 0 ||
                                                    device.signal_quality === 1 ||
                                                    device.signal_quality === 2
                                                "
                                                color="error"
                                                >mdi-network-strength-1-alert
                                            </v-icon>

                                            <v-icon v-else-if="device.signal_quality === 3" color="warning">
                                                mdi-network-strength-3-alert
                                            </v-icon>

                                            <v-icon v-else-if="device.signal_quality === 4" color="success">mdi-network-strength-3</v-icon>

                                            <v-icon v-else-if="device.signal_quality === 5" color="success">mdi-network-strength-4</v-icon>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>

                            <template v-else>
                                <v-icon class="font-color-light"> mdi-cancel</v-icon>
                            </template>
                        </div>
                    </template>
                </div>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import DisplayAssetContentLevelComponent from '@/components/equipment/generic/containment/DisplayAssetContentLevelComponent.vue'
import useAsset from '@/mixin/useAsset'

export default {
    name: 'HiveInformationWidget',
    components: { DisplayAssetContentLevelComponent, WidgetWrapperComponent },
    mixins: [useAsset],
    props: {
        asset: {
            type: Object,
            required: true,
        },
        asset_module: {
            type: Object,
            required: true,
        },
    },
    computed: {
        total_models() {
            return this.asset_module.total_models || 0
        },
        configuration() {
            return this.asset.configuration
        },
        device() {
            return this.$props.asset.devices[0]
        },
    },
    methods: {
        handleWidgetResize() {
            const divWidth = document.getElementById('information-asset-widget-container')?.clientWidth
            const nbAsset = divWidth / 300
            const widgetContainer = document.getElementById('information-asset-widget-container')
            if (widgetContainer) {
                widgetContainer.style.gridTemplateColumns = `repeat(${
                    Math.floor(nbAsset) < this.total_models ? Math.floor(nbAsset) : this.total_models
                }, 1fr)`
            }
        },
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.handleWidgetResize()
        })
        this.handleWidgetResize()
    },
}
</script>

<style scoped>
.information-asset-widget-container {
    display: grid;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
    row-gap: 12px;
    grid-template-columns: repeat(4, 1fr);
}
</style>
